export const MISSED_CLASS_CALENDAR_DIALOG_WAS_SHOWN_SESSION_KEY =
    'missedClassCalendarDialogWasShown';
